import { p as G } from "./styled-components.browser.esm-DBaC0ZEI.mjs";
import * as a from "react";
import { g as J, b as Y, u as V, m as Z, T as ee, a as W, q as O, K as k, s as oe } from "./index-CjjiqU7h.mjs";
import { o as re } from "./omit-B_u6A-HL.mjs";
import { g as te, i as ne, a as le } from "./colors-CS1uQ7ve.mjs";
import { u as ae, p as H } from "./useClosable-DkzVjsgR.mjs";
import { r as se } from "./reactNode-CwSzDQK_.mjs";
import { W as ce } from "./index-CmPT-VFE.mjs";
const ie = (e) => {
  const {
    paddingXXS: t,
    lineWidth: n,
    tagPaddingHorizontal: o,
    componentCls: r,
    calc: c
  } = e, l = c(o).sub(n).equal(), u = c(t).sub(n).equal();
  return {
    // Result
    [r]: Object.assign(Object.assign({}, Y(e)), {
      display: "inline-block",
      height: "auto",
      // https://github.com/ant-design/ant-design/pull/47504
      marginInlineEnd: e.marginXS,
      paddingInline: l,
      fontSize: e.tagFontSize,
      lineHeight: e.tagLineHeight,
      whiteSpace: "nowrap",
      background: e.defaultBg,
      border: `${V(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
      borderRadius: e.borderRadiusSM,
      opacity: 1,
      transition: `all ${e.motionDurationMid}`,
      textAlign: "start",
      position: "relative",
      // RTL
      [`&${r}-rtl`]: {
        direction: "rtl"
      },
      "&, a, a:hover": {
        color: e.defaultColor
      },
      [`${r}-close-icon`]: {
        marginInlineStart: u,
        fontSize: e.tagIconSize,
        color: e.colorTextDescription,
        cursor: "pointer",
        transition: `all ${e.motionDurationMid}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      },
      [`&${r}-has-color`]: {
        borderColor: "transparent",
        [`&, a, a:hover, ${e.iconCls}-close, ${e.iconCls}-close:hover`]: {
          color: e.colorTextLightSolid
        }
      },
      "&-checkable": {
        backgroundColor: "transparent",
        borderColor: "transparent",
        cursor: "pointer",
        [`&:not(${r}-checkable-checked):hover`]: {
          color: e.colorPrimary,
          backgroundColor: e.colorFillSecondary
        },
        "&:active, &-checked": {
          color: e.colorTextLightSolid
        },
        "&-checked": {
          backgroundColor: e.colorPrimary,
          "&:hover": {
            backgroundColor: e.colorPrimaryHover
          }
        },
        "&:active": {
          backgroundColor: e.colorPrimaryActive
        }
      },
      "&-hidden": {
        display: "none"
      },
      // To ensure that a space will be placed between character and `Icon`.
      [`> ${e.iconCls} + span, > span + ${e.iconCls}`]: {
        marginInlineStart: l
      }
    }),
    [`${r}-borderless`]: {
      borderColor: "transparent",
      background: e.tagBorderlessBg
    }
  };
}, N = (e) => {
  const {
    lineWidth: t,
    fontSizeIcon: n,
    calc: o
  } = e, r = e.fontSizeSM;
  return Z(e, {
    tagFontSize: r,
    tagLineHeight: V(o(e.lineHeightSM).mul(r).equal()),
    tagIconSize: o(n).sub(o(t).mul(2)).equal(),
    // Tag icon is much smaller
    tagPaddingHorizontal: 8,
    // Fixed padding.
    tagBorderlessBg: e.defaultBg
  });
}, E = (e) => ({
  defaultBg: new ee(e.colorFillQuaternary).onBackground(e.colorBgContainer).toHexString(),
  defaultColor: e.colorText
}), M = J("Tag", (e) => {
  const t = N(e);
  return ie(t);
}, E);
var de = function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
};
const ge = /* @__PURE__ */ a.forwardRef((e, t) => {
  const {
    prefixCls: n,
    style: o,
    className: r,
    checked: c,
    onChange: l,
    onClick: u
  } = e, d = de(e, ["prefixCls", "style", "className", "checked", "onChange", "onClick"]), {
    getPrefixCls: f,
    tag: g
  } = a.useContext(W), b = (h) => {
    l == null || l(!c), u == null || u(h);
  }, p = f("tag", n), [y, S, i] = M(p), $ = O(p, `${p}-checkable`, {
    [`${p}-checkable-checked`]: c
  }, g == null ? void 0 : g.className, r, S, i);
  return y(/* @__PURE__ */ a.createElement("span", Object.assign({}, d, {
    ref: t,
    style: Object.assign(Object.assign({}, o), g == null ? void 0 : g.style),
    className: $,
    onClick: b
  })));
}), ue = ge, pe = (e) => te(e, (t, n) => {
  let {
    textColor: o,
    lightBorderColor: r,
    lightColor: c,
    darkColor: l
  } = n;
  return {
    [`${e.componentCls}${e.componentCls}-${t}`]: {
      color: o,
      background: c,
      borderColor: r,
      // Inverse color
      "&-inverse": {
        color: e.colorTextLightSolid,
        background: l,
        borderColor: l
      },
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}), Ce = k(["Tag", "preset"], (e) => {
  const t = N(e);
  return pe(t);
}, E);
function me(e) {
  return typeof e != "string" ? e : e.charAt(0).toUpperCase() + e.slice(1);
}
const v = (e, t, n) => {
  const o = me(n);
  return {
    [`${e.componentCls}${e.componentCls}-${t}`]: {
      color: e[`color${n}`],
      background: e[`color${o}Bg`],
      borderColor: e[`color${o}Border`],
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}, fe = k(["Tag", "status"], (e) => {
  const t = N(e);
  return [v(t, "success", "Success"), v(t, "processing", "Info"), v(t, "error", "Error"), v(t, "warning", "Warning")];
}, E);
var be = function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
};
const he = /* @__PURE__ */ a.forwardRef((e, t) => {
  const {
    prefixCls: n,
    className: o,
    rootClassName: r,
    style: c,
    children: l,
    icon: u,
    color: d,
    onClose: f,
    bordered: g = !0,
    visible: b
  } = e, p = be(e, ["prefixCls", "className", "rootClassName", "style", "children", "icon", "color", "onClose", "bordered", "visible"]), {
    getPrefixCls: y,
    direction: S,
    tag: i
  } = a.useContext(W), [$, h] = a.useState(!0), R = re(p, ["closeIcon", "closable"]);
  process.env.NODE_ENV !== "production" && oe("Tag").deprecated(!("visible" in e), "visible", "visible && <Tag />"), a.useEffect(() => {
    b !== void 0 && h(b);
  }, [b]);
  const P = ne(d), j = le(d), T = P || j, q = Object.assign(Object.assign({
    backgroundColor: d && !T ? d : void 0
  }, i == null ? void 0 : i.style), c), s = y("tag", n), [D, F, L] = M(s), A = O(s, i == null ? void 0 : i.className, {
    [`${s}-${d}`]: T,
    [`${s}-has-color`]: d && !T,
    [`${s}-hidden`]: !$,
    [`${s}-rtl`]: S === "rtl",
    [`${s}-borderless`]: !g
  }, o, r, F, L), w = (C) => {
    C.stopPropagation(), f == null || f(C), !C.defaultPrevented && h(!1);
  }, [, X] = ae(H(e), H(i), {
    closable: !1,
    closeIconRender: (C) => {
      const Q = /* @__PURE__ */ a.createElement("span", {
        className: `${s}-close-icon`,
        onClick: w
      }, C);
      return se(C, Q, (m) => ({
        onClick: (_) => {
          var x;
          (x = m == null ? void 0 : m.onClick) === null || x === void 0 || x.call(m, _), w(_);
        },
        className: O(m == null ? void 0 : m.className, `${s}-close-icon`)
      }));
    }
  }), U = typeof p.onClick == "function" || l && l.type === "a", z = u || null, K = z ? /* @__PURE__ */ a.createElement(a.Fragment, null, z, l && /* @__PURE__ */ a.createElement("span", null, l)) : l, B = /* @__PURE__ */ a.createElement("span", Object.assign({}, R, {
    ref: t,
    className: A,
    style: q
  }), K, X, P && /* @__PURE__ */ a.createElement(Ce, {
    key: "preset",
    prefixCls: s
  }), j && /* @__PURE__ */ a.createElement(fe, {
    key: "status",
    prefixCls: s
  }));
  return D(U ? /* @__PURE__ */ a.createElement(ce, {
    component: "Tag"
  }, B) : B);
}), I = he;
process.env.NODE_ENV !== "production" && (I.displayName = "Tag");
I.CheckableTag = ue;
const ve = I, Ee = G(ve)`
  &.ant-tag {
    border: 0;
  }
`;
export {
  Ee as S,
  ve as T
};
//# sourceMappingURL=style-pk1ekFUy.mjs.map
